import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { ContentList } from "./ContentList";

const list1Content = [
  `z opóźnionym rozwojem mowy oraz afazją dziecięcą,`,
  `z wadami wymowy,`,
  <>
    z zaburzeniami miofunkcjonalnymi obszaru ustno-twarzowego m.in. :
    <ContentList
      listContent={[
        `dzieci z wadami zgryzu i np. nieprawidłową pozycją spoczynkową i
pracą języka (terapia przed oraz w trakcie leczenia ortodontycznego),`,
        `z zaburzonym torem oddechowym (oddychaniem przez usta),`,
        `nienormatywnym połykaniem,`,
      ]}
    />
  </>,
  `z zaburzeniami płynności mowy (jąkaniem i giełkotem),
terapia jąkania u dzieci w wieku szkolnym oraz jąkania wczesnodziecięcego
wg podejścia interakcyjnego Palin PCI (Parent-Child Interaction Therapy).`,
  `z centralnymi zaburzeniami przetwarzania słuchowego,`,
  `z mutyzmem wybiórczym,`,
  `z dysleksją,`,
  `wprowadzanie komunikacji wspomagającej i alternatywnej (AAC) m.in. u
dzieci z autyzmem, afazją, apraksją mowy, dziecięcym porażeniem
mózgowym,`,
  `wprowadzanie wczesnej nauki czytania.`,
];

export function ChildrenService() {
  return (
    <Stack>
      <Typography variant="h3" fontWeight={"medium"}>
        TERAPIA DZIECI:
      </Typography>
      <ContentList listContent={list1Content} />
    </Stack>
  );
}
